import { call, put, select } from 'redux-saga/effects';

import { setApplications } from '../../../effects/organization';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getApplications() {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/applications?size=50&page=0`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.GET,
    });

    if (success && !error) {
      yield put(setApplications({ ...result }));
    } else {
      yield put(setApplications({ error: true }));
    }
  } catch (e) {
    console.error(e);
    yield put(setApplications({ error: true }));
  }
}
